<template>
  <!-- TRIP COSTS -->
  <div class="tcp-container">
    <div :id="`itemexpander`" class="tcp-main" :class="{ 'item-active': dropdown }" @click="toggleExpand">
      <div class="item-title">
        <i class="material-icons vtd-icon-4 vtd-mr-3 vtd-align-middle">
          <span>language</span>
        </i>
        <span>DESTINATION ADVICE</span>
      </div>
      <div class="toggle-container d-flex">
        <span v-if="!dropdown">+</span>
        <span v-else>-</span>
      </div>
    </div>

    <DestinationAdviceBody v-if="dropdown" />
  </div>
</template>

<script>
import DestinationAdviceBody from '../../../partials/destination-advice'

export default {
  components: {
    DestinationAdviceBody
  },
  data() {
    return {
      dropdown: true,
    };
  },
  methods: {
    toggleExpand() {
      this.dropdown = !this.dropdown;
    },
  },
};
</script>

<style lang="scss">
@import "./styles.scss";
</style>
